/* La Bottega — comportamento del tema (nessuna dipendenza) */
(function () {
  'use strict';
  var T = window.LBTheme || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var fmt = function (c) {
    var f = T.moneyFormat || '€{{amount_with_comma_separator}}';
    var n = function (cents, dec, th, dp) {
      var s = (cents / 100).toFixed(dec).split('.');
      s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return s.join(dp);
    };
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      switch (k) {
        case 'amount': return n(c, 2, ',', '.');
        case 'amount_no_decimals': return n(c, 0, ',', '.');
        case 'amount_with_comma_separator': return n(c, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return n(c, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return n(c, 2, "'", '.');
        default: return n(c, 2, '.', ',');
      }
    });
  };
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }

  /* ---------- header ---------- */
  var hdr = $('.hdr');
  if (hdr) {
    var onScroll = function () { hdr.classList.toggle('is-stuck', window.scrollY > 10); };
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
  }
  var navWrap = $('[data-nav]');
  $$('[data-nav-toggle]').forEach(function (b) {
    b.addEventListener('click', function () {
      var open = navWrap.classList.toggle('is-open');
      b.setAttribute('aria-expanded', open);
      document.body.style.overflow = open ? 'hidden' : '';
    });
  });
  var srch = $('[data-search]');
  $$('[data-search-toggle]').forEach(function (b) {
    b.addEventListener('click', function () {
      var open = srch.classList.toggle('is-open');
      b.setAttribute('aria-expanded', open);
      if (open) { var f = $('input', srch); if (f) f.focus(); }
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (srch) srch.classList.remove('is-open');
    if (navWrap && navWrap.classList.contains('is-open')) { navWrap.classList.remove('is-open'); document.body.style.overflow = ''; }
    LB.close();
  });

  /* ---------- reveal ---------- */
  document.documentElement.classList.remove('no-js');
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: 0.1 }) : null;
  function watchReveal(root) {
    $$('.rv', root).forEach(function (n) { if (io) io.observe(n); else n.classList.add('in'); });
  }
  watchReveal();

  /* ---------- hero parallax ---------- */
  var stage = $('[data-stage]');
  if (stage && window.matchMedia('(hover:hover)').matches) {
    stage.closest('.hero').addEventListener('mousemove', function (e) {
      var r = stage.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
      $$('.pola', stage).forEach(function (p, i) {
        var d = (i + 1) * 14; p.style.setProperty('--mx', x * d + 'px'); p.style.setProperty('--my', y * d + 'px');
      });
    });
  }

  /* ---------- toast ---------- */
  var toastT;
  function toast(msg) {
    var t = $('.toast') || document.body.appendChild(el('div', 'toast'));
    t.setAttribute('role', 'status'); t.textContent = msg; t.classList.add('show');
    clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove('show'); }, 3200);
  }

  /* ---------- carrello ---------- */
  var drawer = $('#cart-drawer');
  var LB = window.LB = {
    cart: null,
    fmt: fmt,
    open: function () { if (!drawer) { window.location.href = T.routes.cart; return; } drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; },
    close: function () { if (!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); if (!(navWrap && navWrap.classList.contains('is-open'))) document.body.style.overflow = ''; },
    refresh: function () {
      return fetch(T.routes.cartJs, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { LB.cart = c; render(c); return c; });
    },
    add: function (items) {
      return fetch(T.routes.add, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Errore'); return j; }); })
        .then(function () { return LB.refresh(); })
        .then(function () { LB.open(); });
    },
    change: function (key, qty) {
      return fetch(T.routes.change, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
        .then(function (r) { return r.json(); }).then(function (c) { LB.cart = c; render(c); });
    }
  };

  function render(c) {
    $$('[data-cart-count]').forEach(function (n) { n.textContent = c.item_count; n.setAttribute('data-n', c.item_count); });
    if (!drawer) return;
    var body = $('[data-cart-body]', drawer), foot = $('[data-cart-foot]', drawer), ship = $('[data-ship]', drawer);
    body.textContent = '';
    if (!c.items.length) {
      var em = el('div', 'drawer__empty'); em.appendChild(el('p', null, 'Il carrello è vuoto. Il banco no.'));
      var a = el('a', 'btn', 'Vai al tagliere'); a.href = '/#tagliere'; a.addEventListener('click', LB.close); em.appendChild(a);
      body.appendChild(em); foot.hidden = true; ship.hidden = true; return;
    }
    c.items.forEach(function (it) {
      var row = el('div', 'ditem');
      var img = el('img'); img.alt = it.product_title; img.width = 76; img.height = 76; img.loading = 'lazy';
      if (it.image) img.src = it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2'); else img.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
      row.appendChild(img);
      var mid = el('div');
      var t = el('a', 'ditem__t', it.product_title); t.href = it.url; mid.appendChild(t);
      if (it.variant_title) mid.appendChild(el('div', 'ditem__v', it.variant_title));
      var q = el('div', 'qty'); q.setAttribute('data-key', it.key);
      var mi = el('button', null, '−'); mi.type = 'button'; mi.setAttribute('data-qty-step', '-1'); mi.setAttribute('aria-label', 'Meno');
      var inp = el('input'); inp.type = 'text'; inp.value = it.quantity; inp.readOnly = true; inp.setAttribute('aria-label', 'Quantità');
      var pl = el('button', null, '+'); pl.type = 'button'; pl.setAttribute('data-qty-step', '1'); pl.setAttribute('aria-label', 'Più');
      q.appendChild(mi); q.appendChild(inp); q.appendChild(pl); mid.appendChild(q);
      row.appendChild(mid);
      var right = el('div'); right.appendChild(el('div', 'ditem__p', fmt(it.final_line_price)));
      var rm = el('button', 'ditem__rm', 'Rimuovi'); rm.type = 'button'; rm.setAttribute('data-remove', it.key); right.appendChild(rm);
      row.appendChild(right); body.appendChild(row);
    });
    $('[data-cart-subtotal]', drawer).textContent = fmt(c.total_price);
    foot.hidden = false;
    if (T.freeShipping > 0) {
      ship.hidden = false; ship.textContent = '';
      var left = T.freeShipping - c.total_price;
      ship.appendChild(el('div', null, left > 0 ? 'Ti mancano ' + fmt(left) + ' per la spedizione gratuita' : 'Hai la spedizione gratuita 🎉'));
      var bar = el('div', 'ship__bar'), fill = el('i'); fill.style.width = Math.min(100, c.total_price / T.freeShipping * 100) + '%'; bar.appendChild(fill); ship.appendChild(bar);
    } else ship.hidden = true;
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-open-cart]')) { e.preventDefault(); LB.refresh().then(LB.open); return; }
    if (t.closest('[data-close-cart]')) { LB.close(); return; }
    var rm = t.closest('[data-remove]');
    if (rm) { LB.change(rm.getAttribute('data-remove'), 0); return; }
    var st = t.closest('[data-qty-step]');
    if (st) {
      var box = st.closest('.qty'), step = parseInt(st.getAttribute('data-qty-step'), 10);
      var inp = $('input', box), key = box.getAttribute('data-key');
      var next = Math.max(key ? 0 : 1, (parseInt(inp.value, 10) || 1) + step);
      if (key) { LB.change(key, next); }
      else { inp.value = next; if (inp.form && inp.form.hasAttribute('data-autosubmit')) inp.form.submit(); }
    }
  });

  /* form "aggiungi al carrello" via AJAX */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.hasAttribute || !f.hasAttribute('data-ajax-cart')) return;
    e.preventDefault();
    var id = f.elements.id && f.elements.id.value, qty = parseInt((f.elements.quantity && f.elements.quantity.value) || '1', 10) || 1;
    if (!id) return;
    var btn = f.querySelector('[type=submit]'), label = btn && btn.textContent;
    if (btn) { btn.disabled = true; if (btn.classList.contains('btn')) btn.textContent = 'Aggiungo…'; }
    LB.add([{ id: Number(id), quantity: qty }])
      .catch(function (err) { toast(err.message || 'Non sono riuscito ad aggiungerlo.'); })
      .then(function () { if (btn) { btn.disabled = false; if (btn.classList.contains('btn')) btn.textContent = label; } });
  });

  if (drawer) LB.refresh(); // aggiorna il contatore all'apertura della pagina

  /* ---------- pagina prodotto ---------- */
  var pdp = $('[data-pdp]');
  if (pdp) {
    var pj = $('[data-product-json]', pdp), product = pj ? JSON.parse(pj.textContent) : null;
    var main = $('[data-gal-main] img', pdp);
    var thumbs = $$('[data-thumb]', pdp);
    var setThumb = function (b) {
      if (!main || !b) return;
      main.removeAttribute('srcset'); main.removeAttribute('sizes'); main.src = b.getAttribute('data-full'); main.alt = b.getAttribute('data-alt') || '';
      thumbs.forEach(function (x) { x.setAttribute('aria-current', x === b); });
    };
    thumbs.forEach(function (b) { b.addEventListener('click', function () { setThumb(b); }); });
    if (product && product.variants.length > 1) {
      var idInput = $('[name=id]', pdp), priceEl = $('.price', pdp), addBtn = $('[data-add-btn]', pdp);
      var onOpt = function () {
        var chosen = $$('.opt', pdp).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
        var v = product.variants.filter(function (x) { return chosen.every(function (val, i) { return x['option' + (i + 1)] === val; }); })[0];
        if (!v) { addBtn.disabled = true; addBtn.textContent = 'Non disponibile'; return; }
        idInput.value = v.id;
        addBtn.disabled = !v.available; addBtn.textContent = v.available ? 'Aggiungi al carrello' : 'Esaurito';
        priceEl.textContent = '';
        if (v.compare_at_price && v.compare_at_price > v.price) { var s = el('s', 'price__was', fmt(v.compare_at_price)); priceEl.appendChild(s); }
        priceEl.appendChild(el('span', 'price__now', fmt(v.price)));
        priceEl.classList.toggle('price--sale', !!(v.compare_at_price && v.compare_at_price > v.price));
        if (v.featured_image) { var tb = thumbs.filter(function (x) { return x.getAttribute('data-image-id') == v.featured_image.id; })[0]; setThumb(tb); }
        history.replaceState(null, '', '?variant=' + v.id);
      };
      $$('.opt input', pdp).forEach(function (i) { i.addEventListener('change', onOpt); });
    }
  }
})();
